import React from 'react'

import type { DnsRecord } from '@fourthwall/services/dist/DnsApiClient'

export const getErrorTooltipText = (record: DnsRecord) => {
  const error = record.lookupValidationError

  if (error?.type === 'RECORD_NOT_FOUND') {
    return 'This record was not found'
  }

  if (error?.type === 'INCORRECT_TYPE_OR_VALUE') {
    return (
      <>
        <p>This record contains the incorrect value:</p>
        <ul>
          {error.matchedRecords.map(({ type, value }) => (
            <li>
              {type} {value}
            </li>
          ))}
        </ul>
      </>
    )
  }

  if (error?.type === 'DUPLICATED_BASE_DOMAIN') {
    return `The base domain was duplicated as ${error.domainWithDuplicatedBase} instead of ${record.host}`
  }

  if (error?.type === 'SURPLUS_MX_ENTRIES') {
    return (
      <>
        <p>Unnecessary DNS records detected that should be removed:</p>
        <ul>
          {error.additionalMXEntries.map((entry) => (
            <li>{entry}</li>
          ))}
        </ul>
      </>
    )
  }

  if (error?.type === 'RECORD_NOT_UNIQUE') {
    return (
      <>
        <p>There is an extra record that needs to be removed:</p>
        <ul>
          {error.duplicatedRecords.map(({ value }) => (
            <li>{value}</li>
          ))}
        </ul>
      </>
    )
  }

  if (error?.type === 'A_TYPE_AND_AAAA_TYPE_RECORD_CONFLICT') {
    return (
      <>
        <p>There is a conflicting AAAA record that needs to be removed: </p>
        <ul>
          {error.conflictingRecords.map(({ value }) => (
            <li>{value}</li>
          ))}
        </ul>
      </>
    )
  }

  return 'Unknown error. Please contact support'
}
